export const GET_CONFIG_EMAIL = "GET_CONFIG_EMAIL";
export const GET_INTEGRATIONS = "GET_INTEGRATIONS";
export const GET_DOMAIN = "GET_DOMAIN";
export const REMOVE_OAUTH = "REMOVE_OAUTH";
export const GET_ERP_STACK = "GET_ERP_STACK";
export const UPDATE_INTEGRATIONS = "UPDATE_INTEGRATIONS";
export const DELETE_API_KEYS = "DELETE_API_KEYS";
export const INSERT_API_KEY = "INSERT_API_KEY";
